import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

export const SurToggleOverViewPdp: Handler = (props: any) => {
    props.dispatch({
        type: "Pages/CENProductDetails/CENOverviewPDPBlockisExpanded",
    });
};

export const chain = [SurToggleOverViewPdp];

const surToggleOverViewPdp = createHandlerChainRunnerOptionalParameter(chain, {}, "SurToggleOverViewPdp");
export default surToggleOverViewPdp;
